import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const ServiceAreas = lazy(() => import("../pages/service-areas/page"));
const HillsideServiceArea = lazy(() => import("../pages/service-areas/hillside/page"));
const TaylorsHillServiceArea = lazy(() => import("../pages/service-areas/taylors-hill/page"));
const SydenhamServiceArea = lazy(() => import("../pages/service-areas/sydenham/page"));
const CarolineSpringsServiceArea = lazy(() => import("../pages/service-areas/caroline-springs/page"));
const TaylorsLakesServiceArea = lazy(() => import("../pages/service-areas/taylors-lakes/page"));
const DelaheyServiceArea = lazy(() => import("../pages/service-areas/delahey/page"));
const KeilorDownsServiceArea = lazy(() => import("../pages/service-areas/keilor-downs/page"));
const KeilorServiceArea = lazy(() => import("../pages/service-areas/keilor/page"));
const BurnsideServiceArea = lazy(() => import("../pages/service-areas/burnside/page"));
const BurnsideHeightsServiceArea = lazy(() => import("../pages/service-areas/burnside-heights/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/service-areas",
    element: <ServiceAreas />,
  },
  {
    path: "/service-areas/hillside",
    element: <HillsideServiceArea />,
  },
  {
    path: "/service-areas/taylors-hill",
    element: <TaylorsHillServiceArea />,
  },
  {
    path: "/service-areas/sydenham",
    element: <SydenhamServiceArea />,
  },
  {
    path: "/service-areas/caroline-springs",
    element: <CarolineSpringsServiceArea />,
  },
  {
    path: "/service-areas/taylors-lakes",
    element: <TaylorsLakesServiceArea />,
  },
  {
    path: "/service-areas/delahey",
    element: <DelaheyServiceArea />,
  },
  {
    path: "/service-areas/keilor-downs",
    element: <KeilorDownsServiceArea />,
  },
  {
    path: "/service-areas/keilor",
    element: <KeilorServiceArea />,
  },
  {
    path: "/service-areas/burnside",
    element: <BurnsideServiceArea />,
  },
  {
    path: "/service-areas/burnside-heights",
    element: <BurnsideHeightsServiceArea />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
